import React, { useContext } from 'react'
import { FormLayoutRow } from '@pushly/aqe/lib/components'
import { Input } from 'antd'
import { PromptVisitorConditions } from '@pushly/models/lib/structs/prompts/prompt-visitor-conditions'
import { DEFAULT_SESSION_TIME_ON_SITE_SECONDS } from '../../constants'
import { PromptEditorContext } from '../../context'

type Props = {
    value: PromptVisitorConditions | undefined
    onChange: (update: PromptVisitorConditions) => void
}

export const SessionTimeOnSiteCondition: React.FC<Props> = ({ value, onChange }) => {
    const { loading, selectedPromptIdx } = useContext(PromptEditorContext)

    return (
        <FormLayoutRow
            loading={loading}
            layout="vertical"
            label={null}
            value={
                !loading && (
                    <Input
                        key={selectedPromptIdx}
                        placeholder="0"
                        addonAfter="seconds spent on site"
                        className="vc-time-on-site"
                        type="number"
                        min={0}
                        defaultValue={value?.sessionTimeOnSiteSeconds ?? DEFAULT_SESSION_TIME_ON_SITE_SECONDS}
                        onChange={(ev) => {
                            onChange(
                                PromptVisitorConditions.from({
                                    sessionTimeOnSiteSeconds: parseInt(ev.target.value, 10),
                                }),
                            )
                        }}
                    />
                )
            }
        />
    )
}
